import { MapPin, X } from "lucide-react";
import { useLang } from "@/context/LangContext";

export default function DistrictPicker({ seats, district, onChange }) {
  const { t, lang } = useLang();
  const ta = lang === "ta";
  const districts = [...new Map(seats.map((s) => [s.district, s.district_ta])).entries()].sort((a, b) => a[0].localeCompare(b[0]));
  return (
    <div className="relative flex items-center rounded-full bg-white search-shadow pl-4 pr-2" data-testid="map-district-picker">
      <MapPin size={16} className="text-[#8c89ad] shrink-0" />
      <select
        value={district || ""}
        onChange={(e) => onChange(e.target.value || null)}
        className={`flex-1 min-w-0 bg-transparent py-3 pl-2 pr-1 text-[14px] text-[#1a1640] outline-none cursor-pointer ${ta ? "font-tamil" : ""}`}
        aria-label={t("district_label")}
        data-testid="map-district-select"
      >
        <option value="">{t("district_filter")}</option>
        {districts.map(([en, taName]) => (
          <option key={en} value={en}>{ta ? taName : en}</option>
        ))}
      </select>
      {district && (
        <button onClick={() => onChange(null)} className="w-7 h-7 grid place-items-center rounded-full hover:bg-[#f3eedc]" aria-label={t("district_clear")} data-testid="map-district-clear">
          <X size={14} />
        </button>
      )}
    </div>
  );
}
